export default __webpack_public_path__ + "static/media/logoWithName.3d5adb57.png";